import { BASE_API_URL } from "@src/shared/api/api";

export const API = {
  GET_COLD_MATCHING_RESULTS_BY_REQUEST_ID: (
    request_uuid: string,
    candidate_id: string
  ) =>
    `${BASE_API_URL}/matching/cold_matching/results/${request_uuid}/${candidate_id}`,
};
